import type { ArtifactPickKind } from "./protocol";

export const pickKindWords: Record<ArtifactPickKind, string> = {
  chart: "Chart",
  table: "Table",
  tile: "Tile",
  section: "Section",
};
